/**
 * Sets the visibility of the window to the global window.visibile variable
 */

// Set the name of the hidden property and the change event for visibility
let hidden, visibilityChange;
if (typeof document.hidden !== "undefined") {
  // Opera 12.10 and Firefox 18 and later support
  hidden = "hidden";
  visibilityChange = "visibilitychange";
} else if (typeof document.msHidden !== "undefined") {
  hidden = "msHidden";
  visibilityChange = "msvisibilitychange";
} else if (typeof document.webkitHidden !== "undefined") {
  hidden = "webkitHidden";
  visibilityChange = "webkitvisibilitychange";
}

window.visible = true;

document.addEventListener(
  visibilityChange,
  () => {
    window.visible = !document[hidden];
  },
  false
);



// WEBPACK FOOTER //
// ./src/utils/visibility.js